import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/credit-customer-detail',
            name: 'admin-credit-customer-detail',
            component: () => import(/* webpackChunkName: "page-admin-credit-management-credit-customer-detail" */ `./index.vue`),
            meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "授信详情"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "授信管理"
                                        },
                                        {
                                                  name: "授信详情"
                                        }
                              ]
                    }
          }
},
        },
    ],
};
